module.exports = __webpack_public_path__ + "img/anquangan_icon.38d6d926.png";